export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10059.ff723347.jpg";